var exports = {
  "DR": "Box_0__uisqP0",
  "wy": "Box_1__QYTtv7",
  "pv": "Box_2__ubxFA4",
  "J0": "leftRounded__zB4I6t",
  "Aw": "rightRounded__MjrR3y",
  "LU": "hasSubmit__j6O00I",
  "LX": "trailingVisual__JYMGTu",
};

module.exports = exports;
